/* PDP YouChews landing sections — shared behavior.
   <yc-carousel>: scroll-snap track with prev/next arrows and dot pagination.
   Markup contract:
     [data-carousel-track]  scrollable flex container of slides
     [data-carousel-prev] / [data-carousel-next]  optional arrow buttons
     [data-carousel-dots]  optional container; dots are built from slide count
*/
(function () {
  'use strict';

  if (customElements.get('yc-carousel')) return;

  class YcCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      if (!this.track) return;
      this.slides = Array.from(this.track.children);
      if (this.slides.length < 2) {
        this.querySelectorAll('[data-carousel-prev], [data-carousel-next], [data-carousel-dots]').forEach((el) => {
          el.style.display = 'none';
        });
        return;
      }

      this.dotsWrap = this.querySelector('[data-carousel-dots]');
      this.buildDots();

      const prev = this.querySelector('[data-carousel-prev]');
      const next = this.querySelector('[data-carousel-next]');
      if (prev) prev.addEventListener('click', () => this.goTo(this.index() - 1));
      if (next) next.addEventListener('click', () => this.goTo(this.index() + 1));

      this.track.addEventListener('scroll', () => {
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(() => this.syncDots(), 80);
      }, { passive: true });

      this.syncDots();
    }

    slideStep() {
      if (this.slides.length < 2) return this.track.clientWidth;
      return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
    }

    index() {
      const step = this.slideStep();
      return step > 0 ? Math.round(this.track.scrollLeft / step) : 0;
    }

    goTo(i) {
      const clamped = Math.max(0, Math.min(this.slides.length - 1, i));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: clamped * this.slideStep(), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    buildDots() {
      if (!this.dotsWrap) return;
      this.dotsWrap.innerHTML = '';
      this.dots = this.slides.map((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'yc-carousel__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', () => this.goTo(i));
        this.dotsWrap.appendChild(dot);
        return dot;
      });
    }

    syncDots() {
      if (!this.dots) return;
      const current = this.index();
      this.dots.forEach((dot, i) => {
        if (i === current) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }
  }

  customElements.define('yc-carousel', YcCarousel);
})();
